import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Customers',
		url: '/customers',
		icon: 'users',
	}
];

export default class Customers extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button data-id="add-customer" onClick={this.toggle('modalCustomerAdd')} size="sm" color="primary">
						<i className="fa fa-users"/>&nbsp;&nbsp;Add Customer
					</Button>
				</Framework.Components.PageBar>

				<Collections.Customers
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name="Customers"
					object={Objects.CustomerAdd}
					history={this.props.history}
					toggle={this.state['modalCustomerAdd']}
					reportClose={this.reportClose('modalCustomerAdd')}
					afterSave={this.handleAfterSave}
				/>

			</div>
		);
	}
}

